import React from "react"
import { Box } from "@chakra-ui/layout"
import type { ImageProps } from "next/image"
import Image from "next/image"

type Props = {
  imageSrc: string
  props?: Pick<ImageProps, "objectFit" | "priority" | "sizes">
}

export const GiftMembershipProductCard = ({
  imageSrc,
  props,
}: Props): JSX.Element => {
  return (
    <Box position="relative">
      <Image
        {...props}
        src={imageSrc}
        alt="Beautypie Gift Membership"
        width={40}
        height={40}
        quality={85}
        unoptimized={
          process.env.STORYBOOK === "true" ||
          process.env.NODE_ENV === "test" ||
          /\.gif$/.test(`${imageSrc}`)
        }
        priority={props?.priority ?? true}
        sizes={props?.sizes}
        style={{
          width: "100%",
          height: "auto",
        }}
      />
    </Box>
  )
}
